/**
 * Picks v2 or v1 of the Series page based on the redesign flag.
 * Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import SeriesPage   from './SeriesPage';
import SeriesPageV2 from './SeriesPageV2';

export default function SeriesPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? SeriesPageV2 : SeriesPage;
  return <Component {...props} />;
}
